import { IHexSpaceData } from 'js/bubbleCore/types';
import { removeItem } from 'framework/utils/array-utils';

export function removeFromSpace<T>(space: IHexSpaceData<T>, value: T): void {
  removeItem(space.values, value);
}